import { useTheme } from '@mui/material';

import { useOptionalChartSettings } from 'contexts/chart/chart-settings-context';
import { useChartSurfaceDark } from 'contexts/chart/chart-surface-context';
import { ChartMode } from 'components/charts/types/chart-settings.type';

// Explicit `dark`, then the nearest ChartCard, then the chart settings mode, then the app theme.
export const useChartMode = (dark?: boolean): ChartMode => {
  const theme = useTheme();
  const settings = useOptionalChartSettings()?.settings;
  const surfaceDark = useChartSurfaceDark(dark);

  if (surfaceDark !== undefined) return surfaceDark ? 'dark' : 'light';

  return settings?.mode ?? (theme.palette.mode === 'dark' ? 'dark' : 'light');
};
